import { useCachedFlag, type CachedFlag } from '../providers/CachedFlagsProvider'

export default function useNewMergeAnalysisFlag(): CachedFlag<'newMergeAnalysis'> {
  return useCachedFlag('newMergeAnalysis')
}
